// extracted by mini-css-extract-plugin
export default {"appbar":"Main_appbar__LOmIJ","main":"Main_main__-Bnoj","navbar":"Main_navbar__11-sz"};